import { versions } from "./constants";
import { debug } from "../config";

export const getVersion = () => {
  const pathname = document.location.pathname;
  if (pathname.includes("image")) {
    //this must come before the "hotspots" clause because the path is "image-hotspots"
    return versions.image;
  }
  if (pathname.includes("hotspots")) {
    return versions.spin;
  }
  if (debug.version) {
    return debug.version;
  }

  return versions.spin;
};
